import { useState } from "react";
import { ScrollableDialogProps } from "./Dialogs";
import { Button, Grid, TextField, Typography } from "@mui/material";
import { gridSizeMdLg12 } from "@/shared/constants";


interface ModalObservacionComponenteProps {
  texto: string;
  title:string;
  titleModal?: string;
}

export default function ModalObservacionGeneral({ texto, title, titleModal }: Readonly<ModalObservacionComponenteProps>) {

  const [openModalObservacion, setOpenModalObservacion] = useState<boolean>(false);

  if (texto.length <= 39) return <Typography fontSize={15}>{texto}</Typography>

  return <>
    <Typography fontSize={14}/* sx={{textAlign:'justify'}} */>
      {`${texto.substring(0, 40)}...`}
      <Button
        size="small"
        variant="text"
        onClick={() => {
          setOpenModalObservacion(true);
        }} >{'Ver Todo'}</Button>
    </Typography>

    {openModalObservacion && (
      <ScrollableDialogProps
        open={openModalObservacion}
        title={title}
        cancelTextBtn="Cerrar"
        onCloseIcon={() => { setOpenModalObservacion(false) }}
        minWidth="48%"
        contentNode={

          <Grid container spacing={2}>
            <Grid item {...gridSizeMdLg12}>
              <TextField
                value={texto}
                size={"medium"}
                fullWidth
                variant="outlined"
                label={titleModal || 'Observación' }
                type={'text'}
                multiline
                rows={6}
              />
            </Grid>
          </Grid>

        }
      />
    )
    }
  </>

}